package com.nonopn.skywatcher.common.app.pages.map.view

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.home.LocalThunderDetectionModel
import com.nonopn.skywatcher.common.app.pages.map.model.FakeMainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.weather.AlertType
import com.nonopn.skywatcher.common.app.pages.map.model.weather.EtaHolder
import com.nonopn.skywatcher.common.app.pages.map.model.weather.ProbeStatus
import com.nonopn.skywatcher.common.app.pages.map.model.weather.WeatherReport
import com.nonopn.skywatcher.common.app.pages.map.view.alerts.Alerts
import com.nonopn.skywatcher.common.app.pages.map.view.views.AlertBannerAlertsTextOnly
import com.nonopn.skywatcher.common.app.pages.map.view.views.ShowAlertButton
import com.nonopn.skywatcher.common.app.pages.map.view.views.ShowDataBigScreen
import com.nonopn.skywatcher.common.app.pages.map.view.views.ShowDataMediumScreen
import com.nonopn.skywatcher.common.app.pages.map.view.views.ShowDataTinyScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.alert_title_none
import com.nonopn.skywatcher.design.theme.AppColor
import com.nonopn.skywatcher.design.theme.AppSizes
import com.nonopn.skywatcher.design.utils.LocalSubFrame
import com.nonopn.skywatcher.design.utils.LocalSubFrameProvider
import com.nonopn.skywatcher.design.utils.WindowType
import com.nonopn.skywatcher.design.utils.localized
import com.nonopn.skywatcher.design.widgets.DefaultCard
import com.nonopn.skywatcher.design.widgets.defaultCardBackground
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.theme.LocalDarkTheme
import eu.codlab.compose.widgets.TextNormal
import eu.codlab.weather.common.models.WeatherConditionAlertType
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun AlertBannerShowOrHide(modifier: Modifier, model: MainScreenModel) {
    val state by model.states.collectAsState()

    val eta = state.probeStatus?.eta
    val alertType = state.probeStatus?.alertType
    val knownAlert = Alerts.firstOrNull { it.first == eta?.actualAlert() }
        ?: if (null != alertType) {
            Alerts.firstOrNull { it.first == WeatherConditionAlertType.Thunderstorm }
        } else null

    if (null == knownAlert) {
        return
    }

    AlertBanner(modifier, model)
}

@Composable
fun AlertBanner(modifier: Modifier, model: MainScreenModel) {
    val state by model.states.collectAsState()

    val color = defaultCardBackground()
    val eta = state.probeStatus?.eta
    val alertType = state.probeStatus?.alertType
    val knownAlert = Alerts.firstOrNull { it.first == eta?.actualAlert() }
        ?: if (null != alertType) {
            Alerts.firstOrNull { it.first == WeatherConditionAlertType.Thunderstorm }
        } else null

    println("alertType $alertType")

    DefaultCard(
        modifier,
        backgroundColor = color,
    ) {
        if (null == knownAlert) {
            AlertBannerNoAlerts(Modifier.fillMaxSize(), model)
            return@DefaultCard
        }

        AlertBannerAlerts(
            Modifier.fillMaxSize(),
            model,
            eta,
            alertType,
            knownAlert.first,
            knownAlert.second,
            knownAlert.third
        )
    }
}

@Composable
private fun AlertBannerNoAlerts(
    modifier: Modifier,
    model: MainScreenModel,
) {
    val state by LocalThunderDetectionModel.current.states.collectAsState()
    Row(
        modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            Modifier.weight(1.0f).padding(24.dp),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            TextNormal(
                text = Res.string.alert_title_none.localized(),
                textAlign = TextAlign.Center
            )
        }

        if (state.selectedThunderDetection.isAdministrator) {
            Column(Modifier.height(32.dp)) {
                // nothing
            }

            ShowAlertButton(
                modifier = Modifier,
                model = model,
            )
        }
    }
}

@Composable
private fun AlertBannerAlerts(
    modifier: Modifier,
    model: MainScreenModel,
    eta: EtaHolder?,
    alertType: AlertType?,
    type: WeatherConditionAlertType,
    text: StringResource,
    drawable: DrawableResource
) {
    println("AlertBannerAlerts eta=$eta")
    LocalSubFrameProvider(
        modifier
    ) {
        if (null == eta) {
            AlertBannerAlertsTextOnly(
                modifier,
                model,
                type,
                text,
                drawable,
                alertType
            )
            return@LocalSubFrameProvider
        }

        val background = if (LocalDarkTheme.current) {
            AppColor.GraySemiTransparentLight
        } else {
            AppColor.GraySemiTransparentDark
        }

        Image(
            modifier = Modifier.fillMaxSize(),
            painter = painterResource(drawable),
            contentDescription = "",
            contentScale = ContentScale.Crop
        )

        Row(
            Modifier.fillMaxSize().background(background)
                .padding(AppSizes.paddings.default),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSizes.paddings.default)
        ) {
            val modifierData = Modifier.fillMaxSize()

            when (LocalSubFrame.current) {
                WindowType.SMARTPHONE_TINY -> ShowDataTinyScreen(modifierData, model, eta)
                WindowType.SMARTPHONE -> ShowDataTinyScreen(modifierData, model, eta)
                WindowType.PHABLET -> ShowDataMediumScreen(modifierData, model, eta)
                WindowType.TABLET -> ShowDataBigScreen(modifierData, model, eta)
            }
        }
    }
}

@HotPreview(widthDp = 400, heightDp = 150, darkMode = true)
@HotPreview(widthDp = 400, heightDp = 150, darkMode = false)
@Composable
private fun ShowBannerTinyPreview() {
    HotPreviewApp(
        Modifier.fillMaxSize(),
        isDarkTheme = isSystemInDarkTheme(),
        isPreview = true,
        subFrameType = WindowType.SMARTPHONE_TINY
    ) {
        ShowDataTinyScreen(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(
                fakeProbeStatus = ProbeStatus(
                    report = WeatherReport.fake()
                ),
            ),
            EtaHolder.fake
        )
    }
}

@HotPreview(widthDp = 400, heightDp = 150, darkMode = true)
@HotPreview(widthDp = 400, heightDp = 150, darkMode = false)
@Composable
private fun AlertBannerOnlyTinyPreview() {
    HotPreviewApp(
        Modifier.fillMaxSize(),
        isDarkTheme = isSystemInDarkTheme(),
        isPreview = true,
        subFrameType = WindowType.SMARTPHONE_TINY
    ) {
        val mainAlert = Alerts.find { it.first == WeatherConditionAlertType.Thunderstorm }!!

        AlertBannerAlerts(
            Modifier.fillMaxWidth().height(150.dp),
            FakeMainScreenModel(
                fakeProbeStatus = ProbeStatus(
                    report = WeatherReport.fake()
                ),
            ),
            EtaHolder.fake,
            AlertType.ManualRed,
            mainAlert.first,
            mainAlert.second,
            mainAlert.third,
        )
    }
}

@HotPreview(widthDp = 1200, heightDp = 150, darkMode = true)
@HotPreview(widthDp = 1200, heightDp = 150, darkMode = false)
@Composable
private fun AlertBannerOnlyLargePreview() {
    HotPreviewApp(
        Modifier.fillMaxSize(),
        isDarkTheme = isSystemInDarkTheme(),
        isPreview = true,
        subFrameType = WindowType.TABLET
    ) {
        val mainAlert = Alerts.find { it.first == WeatherConditionAlertType.Thunderstorm }!!

        AlertBannerAlerts(
            Modifier.fillMaxWidth().height(150.dp),
            FakeMainScreenModel(
                fakeProbeStatus = ProbeStatus(
                    report = WeatherReport.fake()
                ),
            ),
            EtaHolder.fake,
            AlertType.ManualRed,
            mainAlert.first,
            mainAlert.second,
            mainAlert.third,
        )
    }
}

@HotPreview(widthDp = 400, heightDp = 150 * 13, darkMode = true)
@HotPreview(widthDp = 400, heightDp = 150 * 13, darkMode = false)
@HotPreview(widthDp = 1200, heightDp = 150 * 13, darkMode = true)
@HotPreview(widthDp = 1200, heightDp = 150 * 13, darkMode = false)
@Composable
private fun AlertBannerAlertsTornadoPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme(), isPreview = true) {
        val mainAlert = Alerts.find { it.first == WeatherConditionAlertType.Thunderstorm }!!

        AlertBannerAlerts(
            Modifier.fillMaxWidth().height(150.dp),
            FakeMainScreenModel(
                fakeProbeStatus = ProbeStatus(
                    report = WeatherReport.fake()
                ),
            ),
            EtaHolder.fake,
            AlertType.ManualRed,
            mainAlert.first,
            mainAlert.second,
            mainAlert.third,
        )

        AlertBanner(
            Modifier.fillMaxWidth().height(150.dp),
            FakeMainScreenModel(
                false,
                fakeProbeStatus = ProbeStatus(
                    report = WeatherReport.fake()
                )
            )
        )

        Alerts.forEach {
            AlertBannerAlerts(
                Modifier.fillMaxWidth().height(150.dp),
                FakeMainScreenModel(
                    fakeProbeStatus = ProbeStatus(
                        report = WeatherReport.fake()
                    ),
                ),
                null,
                null,
                it.first,
                it.second,
                it.third
            )
        }
    }
}